import { Badge } from '@/components/ui/Badge'

interface AgingBadgeProps {
  daysPastDue: number | null | undefined
}

export function AgingBadge({ daysPastDue }: AgingBadgeProps) {
  if (daysPastDue == null) {
    return <Badge>—</Badge>
  }

  if (daysPastDue < 30) {
    return <Badge variant="success">{daysPastDue} days</Badge>
  }
  if (daysPastDue < 60) {
    return <Badge variant="warning">{daysPastDue} days</Badge>
  }
  if (daysPastDue < 90) {
    return <Badge className="bg-orange-100 text-orange-800">{daysPastDue} days</Badge>
  }
  return <Badge variant="danger">{daysPastDue} days</Badge>
}
